import { inject, Injectable } from '@angular/core';
import { AuthorizedUser } from '@decorators';
import { AuthState } from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    private readonly authState = inject(AuthState);

    @AuthorizedUser()
    public delete(): Promise<unknown> {
        return this.authState.value()!.delete();
    }
}
